import { TypeCodeState } from '../../types';
import { axiosInstance } from '~/services/fetchServiceV2';

import { useDedupeMutation } from '../common';

/** @category useCommute */
export type TypeCommuteParams = {
  /**
   * 연장 근무 희망 여부
   * @remarks 희망(WISHED), 비희망(NOT_WISHED)
   */
  overWorkWishedStatus: string;
  /** 클러스터 */
  cluster: string;
  /** 센터 */
  center: string;
  /** 업무 파트 */
  workPart: string;
  /** 근무 시프트 */
  workShift: string;
};

/** @category useCommute */
export type TypeCommuteResponse = {
  /** 출근 QR 코드 문자열 */
  qrCode: string;
  /** 연장 근무 희망 여부 */
  overWorkWishedStatus: TypeCodeState;
};

/**
 * @description 상용직 작업자가 출근 정보를 가지고 출근을 처리하는 api 요청에 사용되는 커스텀 훅
 */
export const useCommute = () => {
  const requestCommute = useDedupeMutation<TypeCommuteParams, TypeCommuteResponse>({
    mutationFn: (params: TypeCommuteParams) => {
      const endpoint = '/commutes/contract-start';
      return axiosInstance.post<TypeCommuteResponse>(endpoint, params);
    },
  });

  return requestCommute;
};
